<template>
    <v-card width="100%" class="mt-3 pt-3 pl-3 pr-3" color="#eee">
        <v-row>
            <v-col cols="12" sm="12">
                <h3>{{index}}. {{question.title}}</h3>
            </v-col>
            <v-col cols="12" sm="12">
                <v-row v-for="(t, idx1) in question.title_list" :key="idx1">
                    <v-col cols="12" sm="12">
                        <!-- <v-text-field v-model="t.title" single-line="" class="input_400 ml-6" label="請輸入問題描述"></v-text-field> -->
                        <h3>{{t.title}}</h3>
                    </v-col>
                    <v-data-table :headers="[]" :items="question.description_list" hide-default-footer hide-default-header="" class="elevation-1 ml-6">
                        <template v-slot:item="{item}">
                            <tr v-if="item.headers_id!==0" style="text-align: center;">
                                <td style="text-align: left; min-width: 200px;">{{item.title}}</td>
                                <td v-for="(v, idx2) in question.headers_list[question.headers_list.findIndex(e=> e.id==item.headers_id)].headers" :key="'h'+idx1+'_'+idx2">
                                    <input type="radio" :name="'h'+idx1+'_'+item.id" disabled/> {{v.title}}
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-row>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
export default {
    props:{
        index: {
            type: Number,
            default: -1,
        },
        question: {
            type: Object, 
            default: {
                title: '',
                headers_list: [],
                title_list: [],
                description_list: [],
            }
        },
    },
    data(){
        return{
            headers: [],
            table_data: [],
            header_text_id: {},
            ans_dict: {}
        }
    },
    mounted(){
        this.construct()
    },
    methods: {
        construct(){
            for(let i in this.question.table_list){
                let tdata = this.question.table_list[i]
                let theaders = [{text: tdata.title, align: 'left', value: 'title', width: 200, sortable: false}]

                let tmp = this.question.headers_list[tdata.headers_idx]
                for(let t of tmp){
                    theaders.push({text: t.title, align: 'center', value: 'h'+t.id, width: 200, sortable: false})
                }
                this.table_list.push({headers: theaders, table_data: tdata.table_data})
            }
        }
    },
}
</script>

<style lang="scss" scoped>

::v-deep .input_100{
    max-width: 100px;
}

</style>